import { createRouter, createWebHistory } from 'vue-router'
import Apps from '../views/Apps.vue'
import store from '../store'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/auth/Login.vue'),
    meta: {
      title: `เข้าสู่ระบบ`,
    }
  },
  {
    path: '/sso/callback',
    name: 'sso-callback',
    component: () => import('../views/auth/SsoCallback.vue'),
    meta: {
      title: `SSO Callback`,
    }
  },
  {
    path: '/vgen',
    name: 'vgen',
    component: () => import('../views/VG/Main.vue'),
    meta: {
      title: `vgen`,
    }
  },
  {
    path: '/create-digital-signature',
    name: 'CreateDigitalSignature',
    component: () => import('@/views/CreateDigitalSignature.vue'),
    meta: {
      title: `CreateDigitalSignature`
    }
  },
  {
    path: '/',
    name: 'home',
    component: Apps,
    redirect: 'dashboard',
    meta: {
      requiresAuth: true,
      title: `หน้าหลัก`,
      roles: ['admin', 'manager', 'user'],
    },
    children: [
      {
        path: '/profile',
        name: 'profile',
        component: () => import('../views/layouts/Profile.vue'),
        meta: {
          title: `ข้อมูลส่วนตัว`
        }
      },
      {
        path: '',
        name: 'dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: {
          title: `หนัาหลัก`
        }
      },
      {
        path: '/doctor',
        name: 'doctor',
        component: () => import('@/views/Doctor.vue'),
        meta: {
          title: `แพทย์`
        }
      },

      {
        path: '/nurse',
        name: 'nurse',
        component: () => import('@/views/Nurse.vue'),
        meta: {
          title: `พยาบาล`
        }
      },
      {
        path: '/dentist',
        name: 'dentist',
        component: () => import('@/views/Dentist.vue'),
        meta: {
          title: `ทันตแพทย์`
        }
      },
      {
        path: '/pharmacist',
        name: 'pharmacist',
        component: () => import('@/views/Pharmacist.vue'),
        meta: {
          title: `เภสัชกร`
        }
      },
      {
        path: '/public-health-technical-officer',
        name: 'publichealthtechnicalofficer',
        component: () => import('@/views/PublicHealthTechnicalOfficer.vue'),
        meta: {
          title: `นักวิชาการสาธารณสุข `
        }
      },
      {
        path: '/opduser',
        name: 'opduser',
        component: () => import('@/views/Opduser.vue'),
        meta: {
          title: `opduser`
        }
      },
      {
        path: '/test',
        name: 'test',
        component: () => import('@/views/Test.vue'),
        meta: {
          title: `Test`
        }
      },
      {
        path: '/checkerrors',
        name: 'checkerrors',
        component: () => import('../views/CheckError.vue'),
        meta: {
          title: `checkerrors`
        }
      },
      {
        path: '/search-vn',
        name: 'SearchVn',
        component: () => import('@/views/SearchVn.vue'),
        meta: {
          title: `SearchVn`
        }
      },
      {
        path: '/lab-secret',
        name: 'LabSecret',
        component: () => import('@/views/LabSecret.vue'),
        meta: {
          title: `LabSecret`
        }
      },
      {
        path: '/doctor-queue',
        name: 'DoctorQueue',
        component: () => import('@/views/DoctorQueue.vue'),
        meta: {
          title: `DoctorQueue`
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {

  document.title = `${to.meta.title} | ${process.env.VUE_APP_NAME_EN}`

  const isAuthenticated = store.getters.isAuthenticated;

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next({ name: 'login' });
  } else if (to.matched.some(record => record.meta.requiresGuest) && isAuthenticated) {

    if (to.meta?.roles?.includes(store.state.role)) {
      next()
    } else {
      next({ name: "dashboard" })
    }
  } else {
    next();
  }
});

export default router
